function initSliderScript() {
    const slider_script_js = document.createElement('script');
    slider_script_js.id = 'sliders-js';
    slider_script_js.src = document.querySelector('[name="slides_init_script_src"]').value;

    document.body.appendChild(slider_script_js);
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initSliderScript, 500);
});
